export enum UserRole {
  Creator = 'creator',
  Admin = 'admin',
  Subscriber = 'subscriber',
  System = 'system',
}
